import { appConstantSettings } from 'srcReact/appConstantSettings'
import { feedConstants as fc } from 'srcReact/FeedPage'
import { feedService, groupHomeService } from 'srcReact/services'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY

export const generalFeedActions = {
  setSelectedNewsFeed,
  deleteFileFromGroup,
  addStaffRole,
  removeStaffRole,
  getGeneralFeedCTAs,
  getNewMembersCTA
}

function setSelectedNewsFeed(newsFeed) {
  return { type: fc.SELECTED_NEWSFEED, newsFeed }
}

function deleteFileFromGroup(groupId, fileId) {
  return (dispatch) => {
    dispatch(request({ groupId, fileId }))

    groupHomeService.deleteFileFromGroup(groupId, fileId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.DELETE_FILE_REQUEST, response }
  }
  function success(response) {
    return { type: fc.DELETE_FILE_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.DELETE_FILE_FAILURE, error }
  }
}

function addStaffRole(groupId, userId, role) {
  return (dispatch) => {
    dispatch(request({ groupId, userId, role }))

    groupHomeService.addStaffRole(groupId, userId, role).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.ADD_STAFF_ROLE_REQUEST, response }
  }
  function success(response) {
    return { type: fc.ADD_STAFF_ROLE_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.ADD_STAFF_ROLE_FAILURE, error }
  }
}

function removeStaffRole(groupId, userId, scope) {
  return (dispatch) => {
    dispatch(request({ groupId, userId }))

    groupHomeService.removeStaffRole(groupId, userId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.REMOVE_STAFF_ROLE_REQUEST, response }
  }
  function success(response) {
    return { type: fc.REMOVE_STAFF_ROLE_SUCCESS, response, scope }
  }
  function failure(error) {
    return { type: fc.REMOVE_STAFF_ROLE_FAILURE, error }
  }
}

function getGeneralFeedCTAs(
  organizationId,
  workplaceIds,
  scope,
  nextOffset = 0,
  quantity = appConstantSettings.PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ organizationId, workplaceIds, scope }))

    feedService.getGeneralFeedCTAs(organizationId, workplaceIds, scope, nextOffset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.GET_FEED_CTA_REQUEST, response }
  }
  function success(response) {
    return { type: fc.GET_FEED_CTA_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.GET_FEED_CTA_FAILURE, error }
  }
}

function getNewMembersCTA(
  organizationId,
  workplaceIds,
  scope,
  nextOffset,
  isPagination,
  quantity = appConstantSettings.PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ organizationId, workplaceIds, scope, nextOffset, isPagination }))

    feedService.getGeneralFeedCTAs(organizationId, workplaceIds, scope, nextOffset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.GET_NEW_MEMBERS_CTA_REQUEST, response }
  }
  function success(response) {
    return { type: fc.GET_NEW_MEMBERS_CTA_SUCCESS, response, isPagination }
  }
  function failure(error) {
    return { type: fc.GET_NEW_MEMBERS_CTA_FAILURE, error }
  }
}
